import React from 'react';
import diagWhiteDxReverse from '../assets/graphics/diagonal_white_dx_reverse.png';
import diagDarkgrayRev from '../assets/graphics/diagonal_darkgray_reverse.png';
import diagDarkgrayTop from '../assets/graphics/diagonal_darkgray_top.png';
import digital from '../assets/logo/digitalLogoSM.png';
import events from '../assets/logo/eventsLogoSM.png';
import paper from '../assets/logo/paperLogoSM.png';
import { useDispatch } from 'react-redux';
import { setServiceCategory } from '../states/navigationState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Home_OurServices = () => {

    const dispatch = useDispatch();
    const isIta = useSelector((state) => state.createUser.languageIta);

    return (
        <div className='text-light bg-transparent'>
            <div className='bg-transparent'>

                <div style={{ backgroundImage: `url(${diagWhiteDxReverse})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}></div>

                <div className="bg-transparent" style={{ height: "150px" }}>
                    {/* this is my spacer */}
                </div>

                <div style={{ backgroundImage: `url(${diagDarkgrayRev})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}>
                    <div className='d-flex justify-content-center'>
                        <div className='p-2 px-3 text-center' style={{ maxWidth: "700px" }}>
                            <div className='d-flex justify-content-center gap-2'>
                                <div className='myBgAcqua rounded-4 p-3'>
                                    <div className=' myFontSize38'>MAR</div>
                                </div>
                                <div className='myBgFucsia rounded-4 p-3 '>
                                    <div className=' myFontSize38'>KET</div>
                                </div>
                                <div className='myBgBlue rounded-4 p-3'>
                                    <div className=' myFontSize38'>ING</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='myBgDarkgray p-2 px-3 py-5 d-flex justify-content-center'>
                    <div style={{ maxWidth: "800px" }}>

                        <div>
                            <div className='d-flex flex-column align-items-center gap-3 pt-5'>
                                <img className='myLogo100' src={digital} alt="" />
                                <h1 className='montserrat-alternates-medium display-4 fw-bold'>{isIta ? "Digitale" : "Digital"}</h1>
                            </div>
                            {
                                isIta ?

                                    <p className='myFontSize22 myTextLightgray'>
                                        <i>Il digitale parla da sé. Con i nostri strumenti di <b>marketing digitale</b> raggiungete <b>distributori</b> di prodotti dentali e medicali, <b>dentisti</b> e <b>laboratori odontotecnici</b> in <b>tutto il mondo</b>, ottimizzando l’investimento e massimizzando i risultati.
                                            Grazie a <b>oltre 30 anni di esperienza</b> come punto di riferimento della stampa di settore, diffondiamo con autorevolezza le ultime novità del mondo dentale e medicale, integrando tradizione e innovazione in un’unica strategia efficace.
                                        </i>
                                    </p>
                                    : <p className='myFontSize22 myTextLightgray'>
                                        <i>Digital speaks for itself. With our <b>digital marketing</b> tools, you can reach <b>dental and medical product distributors</b>, <b>dentists</b>, and <b>dental laboratories worldwide</b>, optimizing your investment and maximizing results.
                                            Thanks to <b>over 30 years of experience</b> as a leading reference in the trade press, we authoritatively share the latest developments in the dental and medical fields, integrating tradition and innovation into a single effective strategy.
                                        </i>
                                    </p>

                            }
                            <Link className='noDecoration' to={"/ourservices"}><div className='d-flex align-items-baseline text-primary myCursor' onClick={() => { dispatch(setServiceCategory("Digital")) }}><p className='fw-bold'>{isIta ? "I Nostri Servizi Digitali" : "Our Digital Services"} </p><i className="bi bi-caret-right-fill ms-2"></i></div></Link>
                        </div>
                        <hr />
                        <div>
                            <div className='d-flex flex-column align-items-center gap-3 pt-5'>
                                <img className='myLogo100' src={events} alt="" />
                                <h1 className='montserrat-alternates-medium display-4 fw-bold'>{isIta ? "Eventi" : "Events"}</h1>
                            </div>
                            {
                                isIta ?
                                    <p className='myFontSize22 myTextLightgray'>
                                        <i>Il business nasce dalle relazioni. Siamo presenti nelle principali <b>fiere internazionali del settore dentale e medicale</b>, offrendo ai nostri clienti visibilità e posizionamento strategico.
                                            Partecipare con noi significa avere un <b>supporto dedicato che gestisce ogni aspetto organizzativo e burocratico</b>, garantendovi una presenza privilegiata e senza pensieri.
                                            Unitevi a noi ed <b>espandete la vostra rete commerciale</b> in modo efficace e professionale.
                                        </i>
                                    </p>
                                    : <p className='myFontSize22 myTextLightgray'>
                                        <i>
                                            Business is built on relationships. We are present at the leading <b>international dental and medical trade shows</b>, offering our clients enhanced visibility and strategic positioning.
                                            Participating with us means having <b>dedicated support that manages every organizational and bureaucratic aspect</b>, ensuring a privileged and worry-free presence.
                                            Join us and <b>expand your commercial network</b> effectively and professionally.
                                        </i>
                                    </p>
                            }
                            <Link className='noDecoration' to={"/ourservices"}><div className='d-flex align-items-baseline myTextFucsia myCursor' onClick={() => { dispatch(setServiceCategory("Events")) }}><p className='fw-bold'>{isIta ? "I Nostri Sevizi Evento" : "Our Events Services"} </p><i className="bi bi-caret-right-fill ms-2"></i></div></Link>
                        </div>
                        <hr />
                        <div>
                            <div className='d-flex flex-column align-items-center gap-3 pt-5'>
                                <img className='myLogo100' src={paper} alt="" />
                                <h1 className='montserrat-alternates-medium display-4 fw-bold'>{isIta ? "Riviste" : "Paper"}</h1>
                            </div>{
                                isIta ?
                                    <p className='myFontSize22 myTextLightgray'><i>Nel 1994 nasce Infodent International, una delle riviste leader del settore dentale da oltre 30 anni. In questo trentennio <b>hanno circolato, nelle fiere dentali di tutto il mondo, più di 2 milioni di copie cartacee!</b></i></p>
                                    : <p className='myFontSize22 myTextLightgray'><i>1994 saw the birth of Infodent International, one of the dental industry's leading magazines for more than 30 years. In this 30-year period, <b>more than 2 million hard copies have circulated at dental fairs around the world!</b></i></p>
                            }
                            <div className='bg-dark d-flex flex-wrap justify-content-center p-1 py-5 my-5 '>
                                {
                                    ["infodent", "infomedix", "tabloid", "inewsids", "inewsidem", "inews", "implantbook"].map((el) => {
                                        return <img className='img-fluid m-1' src={require(`../assets/mockUp/${el}.png`)} />
                                    })
                                }
                            </div>
                            {
                                isIta ?
                                    <p className='myFontSize22 myTextLightgray'><i>Dal 1994, Infodent Srl ha pubblicato numerose riviste sia in campo dentale che medicale, arrivando a <b>portare 7 titoli di eccellenza in tutto il mondo.</b> </i></p>
                                    : <p className='myFontSize22 myTextLightgray'><i>Since 1994, Infodent Srl has published several titles in both the dental and medical fields, now <b>carrying 7 titles of excellence worldwide.</b> </i></p>
                            }
                            <Link className='noDecoration' to={"/ourservices"}><div className='d-flex align-items-baseline text-info myCursor mt-3' onClick={() => { dispatch(setServiceCategory("Paper")) }}><p className='fw-bold'>{isIta ? "Le Nostre Riviste" : "Our Paper Services"} </p><i className="bi bi-caret-right-fill ms-2"></i></div></Link>
                        </div>
                        <div className="myBgDarkgray" style={{ height: "50px" }}>
                            {/* this is my spacer */}
                        </div>

                    </div>
                </div>
                
                <div style={{ backgroundImage: `url(${diagDarkgrayTop})`, height: "100px", backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "100% 100%" }}></div>
                <div className="bg-transparent" style={{ height: "300px" }}>
                    {/* this is my spacer */}
                </div>
            </div>

        </div>
    )
}

export default Home_OurServices